import React, { useState, useEffect, Fragment } from 'react';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css';
import Moment from 'moment';
import Popover from 'react-tiny-popover';
import MensajeAvior from './MensajeAdvertencia';
import LoaderScreen from '../layout/LoaderScreen';
import { useTranslation } from 'react-i18next';
import 'moment/locale/es';

const Paso1 = (props) => {
    const { t, i18n } = useTranslation();
    Moment.locale(i18n.language === 'es' ? 'es' : 'en');
    
    const [ActivarLoader, setActivarLoader] = useState(false);

    // Estados principales del formulario
    const [tieneDocumentos, setTieneDocumentos] = useState(null);
    const [tipoIngreso, setTipoIngreso] = useState('localizador'); // 'ticket' o 'localizador'

    // Campos para tipoIngreso === 'ticket'
    const [numeroTicketUnico, setNumeroTicketUnico] = useState("");
    const [errorTicketUnico, setErrorTicketUnico] = useState("");

    // Campos para tipoIngreso === 'localizador'
    const [localizador, setLocalizador] = useState("");
    const [errorLocalizador, setErrorLocalizador] = useState("");
    const [especificarTicketsLocalizador, setEspecificarTicketsLocalizador] = useState(false);
    const [ticketsDelLocalizador, setTicketsDelLocalizador] = useState(['']);
    const [erroresTicketsLocalizador, setErroresTicketsLocalizador] = useState([]);

    // Campo común
    const [fechaCompra, setFechaCompra] = useState(Moment(new Date()));
    const [ActivarPopoverFechas, setActivarPopoverFechas] = useState(false);

    const LONGITUD_LOCALIZADOR = 6;
    const LONGITUD_TICKET = 13;
    const PREFIJO_TICKET = "742";

    // Validaciones
    const esAlfanumerico = (inputtxt) => /^[A-Za-z0-9]+$/.test(inputtxt);
    const solonumeros = (inputtxt) => /^[0-9]+$/.test(inputtxt);

    const validarFormatoLocalizador = (loc) => {
        if (!loc || loc.trim() === "") return t('paso1.errorLocRequerido', 'El Booking / Localizador es requerido.');
        if (!esAlfanumerico(loc)) return t('paso1.errorLocAlfanumerico', 'Debe contener solo letras y números.');
        if (loc.length !== LONGITUD_LOCALIZADOR) return t('paso1.errorLocLongitud', `Debe tener ${LONGITUD_LOCALIZADOR} caracteres.`);
        return "";
    };

    const validarFormatoTicket = (ticket) => {
        if (!ticket || ticket.trim() === "") return t('paso1.errorTktRequerido', 'El número de ticket es requerido.');
        if (!solonumeros(ticket)) return t('paso1.errorTktNumeros', 'El ticket debe contener solo números.');
        if (ticket.length !== LONGITUD_TICKET) return t('paso1.errorTktLongitud', `El ticket debe tener ${LONGITUD_TICKET} dígitos.`);
        if (!ticket.startsWith(PREFIJO_TICKET)) return t('paso1.errorTktPrefijo', `El ticket debe iniciar con ${PREFIJO_TICKET}.`);
        return "";
    };

    // Storage
    const construirYGuardarValorBoletoStorage = () => {
        if (!tieneDocumentos) {
            window.localStorage.removeItem("Boleto");
            return;
        }

        let parts = [];
        parts.push(`Tipo:${tipoIngreso}`);

        if (tipoIngreso === 'ticket') {
            parts.push(`TicketNro:${numeroTicketUnico || 'N/A'}`);
        } else if (tipoIngreso === 'localizador') {
            parts.push(`Loc:${localizador || 'N/A'}`);
            parts.push(`EspecificarTickets:${especificarTicketsLocalizador}`);
            if (especificarTicketsLocalizador) {
                const ticketsValidos = ticketsDelLocalizador.filter(t => t && t.trim() !== "");
                if (ticketsValidos.length > 0) {
                    parts.push(`Tickets:[${ticketsValidos.join(',')}]`);
                } else {
                    parts.push(`Tickets:[]`);
                }
            }
        }
        window.localStorage.setItem("Boleto", parts.join('; '));
    };

    const parsearYEstablecerValorBoletoStorage = (cadenaBoleto) => {
        if (!cadenaBoleto) return;

        const data = {};
        cadenaBoleto.split('; ').forEach(part => {
            const [key, ...valueParts] = part.split(':');
            const value = valueParts.join(':');
            data[key] = value;
        });

        if (data.Fecha && data.Fecha !== 'N/A') setFechaCompra(Moment(data.Fecha));

        const tipo = data.Tipo || 'localizador';
        setTipoIngreso(tipo);

        if (tipo === 'ticket') {
            setNumeroTicketUnico(data.TicketNro !== 'N/A' ? data.TicketNro : "");
        } else if (tipo === 'localizador') {
            setLocalizador(data.Loc !== 'N/A' ? data.Loc : "");
            const especificar = data.EspecificarTickets === 'true';
            setEspecificarTicketsLocalizador(especificar);
            if (especificar && data.Tickets && data.Tickets !== '[]') {
                const ticketsStr = data.Tickets.substring(1, data.Tickets.length - 1);
                if (ticketsStr) {
                    setTicketsDelLocalizador(ticketsStr.split(','));
                } else {
                    setTicketsDelLocalizador(['']);
                }
            } else if (especificar) {
                setTicketsDelLocalizador(['']);
            }
        }
    };

    // Eventos
    const resetearCamposSegunTipo = (nuevoTipo) => {
        setNumeroTicketUnico("");
        setErrorTicketUnico("");
        setLocalizador("");
        setErrorLocalizador("");
        setEspecificarTicketsLocalizador(false);
        setTicketsDelLocalizador(['']);
        setErroresTicketsLocalizador([]);
    };

    const handleTieneDocumentosChange = (valorString) => {
        if (valorString === "null") {
            setTieneDocumentos(null);
            window.localStorage.removeItem("TieneDocumentos");
            return;
        }
        const posee = valorString === "true";
        setTieneDocumentos(posee);
        window.localStorage.setItem("TieneDocumentos", posee.toString());
        if (!posee) {
            resetearCamposSegunTipo(tipoIngreso);
            setFechaCompra(Moment(new Date()));
            window.localStorage.removeItem("Boleto");
            window.localStorage.setItem("Paso1", btoa(true));
        } else {
            CamposObligatoriosCorrectos();
        }
    };

    const handleTipoIngresoChange = (event) => {
        const nuevoTipo = event.target.value;
        resetearCamposSegunTipo(nuevoTipo);
        setTipoIngreso(nuevoTipo);
        CamposObligatoriosCorrectos();
    };

    const handleFechaChange = (value) => {
        setFechaCompra(value);
        setActivarPopoverFechas(false);
        CamposObligatoriosCorrectos();
    };

    const handleTicketUnicoChange = (valor) => {
        if (valor.length <= LONGITUD_TICKET && (solonumeros(valor) || valor === "")) {
            setNumeroTicketUnico(valor);
        }
        CamposObligatoriosCorrectos();
    };
    const handleTicketUnicoBlur = () => {
        setErrorTicketUnico(validarFormatoTicket(numeroTicketUnico));
        CamposObligatoriosCorrectos();
    };

    const handleLocalizadorChange = (valor) => {
        const valorUpper = valor.toUpperCase();
        if (valorUpper.length <= LONGITUD_LOCALIZADOR && (esAlfanumerico(valorUpper) || valorUpper === "")) {
            setLocalizador(valorUpper);
        }
        CamposObligatoriosCorrectos();
    };
    const handleLocalizadorBlur = () => {
        setErrorLocalizador(validarFormatoLocalizador(localizador));
        CamposObligatoriosCorrectos();
    };
    const handleEspecificarChange = (event) => {
        const checked = event.target.checked;
        setEspecificarTicketsLocalizador(checked);
        if (!checked) {
            setTicketsDelLocalizador(['']);
            setErroresTicketsLocalizador([]);
        }
        CamposObligatoriosCorrectos();
    };

    const handleTicketLocalizadorChange = (index, valor) => {
        if (valor.length <= LONGITUD_TICKET && (solonumeros(valor) || valor === "")) {
            const nuevos = [...ticketsDelLocalizador];
            nuevos[index] = valor;
            setTicketsDelLocalizador(nuevos);
        }
        CamposObligatoriosCorrectos();
    };
    const handleTicketLocalizadorBlur = (index) => {
        const ticket = ticketsDelLocalizador[index];
        const nuevosErrores = [...erroresTicketsLocalizador];
        nuevosErrores[index] = (ticket && ticket.trim() !== "") ? validarFormatoTicket(ticket) : "";
        setErroresTicketsLocalizador(nuevosErrores);
        CamposObligatoriosCorrectos();
    };
    const addTicketLocalizadorInput = () => {
        setTicketsDelLocalizador([...ticketsDelLocalizador, '']);
        setErroresTicketsLocalizador([...erroresTicketsLocalizador, '']);
    };
    const removeTicketLocalizadorInput = (index) => {
        const nuevosTickets = ticketsDelLocalizador.filter((_, i) => i !== index);
        const nuevosErrores = erroresTicketsLocalizador.filter((_, i) => i !== index);
        setTicketsDelLocalizador(nuevosTickets.length > 0 ? nuevosTickets : ['']);
        setErroresTicketsLocalizador(nuevosErrores);
        CamposObligatoriosCorrectos();
    };

    // UseEffect
    function LimpiarTodoParaInicio() {
        window.localStorage.removeItem("TieneDocumentos");
        window.localStorage.removeItem("Boleto");
        window.localStorage.setItem("Paso1", btoa(false));

        setTieneDocumentos(null);
        setTipoIngreso('localizador');
        resetearCamposSegunTipo('localizador');
        setFechaCompra(Moment(new Date()));
    }

    useEffect(() => {
        LimpiarTodoParaInicio();
        const tieneDocsGuardado = window.localStorage.getItem("TieneDocumentos");
        if (tieneDocsGuardado === null) {
            setTieneDocumentos(null);
        } else if (tieneDocsGuardado === "true") {
            setTieneDocumentos(true);
        } else {
            setTieneDocumentos(false);
        }

        if (tieneDocsGuardado === "true") {
            const boletoStorage = window.localStorage.getItem("Boleto");
            parsearYEstablecerValorBoletoStorage(boletoStorage);
        } else {
            window.localStorage.setItem("Paso1", btoa(true));
        }
    }, []);

    useEffect(() => {
        if (tieneDocumentos === true) {
            construirYGuardarValorBoletoStorage();
        }
        CamposObligatoriosCorrectos();
    }, [tieneDocumentos, tipoIngreso, numeroTicketUnico, localizador, especificarTicketsLocalizador, ticketsDelLocalizador, fechaCompra]);

    async function CamposObligatoriosCorrectos() {
        if (!tieneDocumentos) {
            window.localStorage.setItem("Paso1", btoa(true));
            return;
        }

        let pasoValidoGlobal = true;

        if (!fechaCompra || !fechaCompra.isValid() || fechaCompra.isAfter(Moment(), 'day')) {
            pasoValidoGlobal = false;
        }

        if (tipoIngreso === 'ticket') {
            const errTkt = validarFormatoTicket(numeroTicketUnico);
            if (errTkt !== "") pasoValidoGlobal = false;
        } else if (tipoIngreso === 'localizador') {
            const errLoc = validarFormatoLocalizador(localizador);
            if (errLoc !== "") pasoValidoGlobal = false;

            if (especificarTicketsLocalizador) {
                const ticketsActivos = ticketsDelLocalizador.filter(t => t.trim() !== "");
                if (ticketsActivos.length === 0) {
                    pasoValidoGlobal = false;
                    const tempErrores = [...erroresTicketsLocalizador];
                    if (ticketsDelLocalizador.length > 0 && ticketsDelLocalizador[0].trim() === "") {
                        tempErrores[0] = t('paso1.errorTktMinimo', "Al menos un ticket es requerido.");
                        setErroresTicketsLocalizador(tempErrores)
                    }
                } else {
                    let todosSubTicketsValidos = true;
                    ticketsDelLocalizador.forEach(subTicket => {
                        if (subTicket.trim() === "" && ticketsActivos.length > 0 && ticketsDelLocalizador.length > 1) return "";
                        const err = validarFormatoTicket(subTicket);
                        if (err !== "") todosSubTicketsValidos = false;
                    });
                    if (!todosSubTicketsValidos) pasoValidoGlobal = false;
                }
            }
        }

        window.localStorage.setItem("Paso1", btoa(pasoValidoGlobal));
    }

    return (
        <>
            <LoaderScreen props={ActivarLoader} mensaje={t('paso1.validandoInformacion', "Validando información")} />
            <div className="_pt-30 container-fluid px-0">
                <div className="theme-page-section-header _ta-l">
                    <h5 className="theme-page-section-title">{t('paso1.titulo', 'Información de Reembolso')}</h5>
                    <h5 className="feature-subtitle _op-06">{t('paso1.subtitulo', 'Todos los campos marcados con (*) son obligatorios.')}</h5>
                    <hr className="style-3" />
                </div>

                <div className="row mt-4">
                    <div className="col-12 col-md-6 mb-3">
                        <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso1.poseeDocumentos', '¿Posee usted documentos para el reembolso?')}</h5>
                        <div className="theme-payment-page-form-item form-group">
                            <i className="fa fa-angle-down"></i>
                            <select
                                className="form-control seleccionable w-100"
                                value={tieneDocumentos === null ? "null" : tieneDocumentos.toString()}
                                onChange={(e) => handleTieneDocumentosChange(e.target.value)}
                            >
                                <option value="null">{t('comunes.seleccione', 'Seleccione')}</option>
                                <option value="false">{t('comunes.no', 'No')}</option>
                                <option value="true">{t('comunes.si', 'Sí')}</option>
                            </select>
                        </div>
                    </div>
                </div>
                {tieneDocumentos === true && (
                    <Fragment>
                        <div className="row mt-3">
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso1.tipoDocumento', 'Tipo de Documento')}</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <i className="fa fa-angle-down"></i>
                                    <select
                                        className="form-control seleccionable w-100"
                                        value={tipoIngreso}
                                        onChange={handleTipoIngresoChange}
                                    >
                                        <option value="localizador">{t('paso1.localizador', 'Booking / Localizador')}</option>
                                        <option value="ticket">{t('paso1.ticket', 'Ticket')}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso1.fechaCompra', 'Fecha de compra/reserva')}</h5>
                                <div className="theme-payment-page-form-item form-group">
                                    <Popover
                                        containerClassName={"text-center"}
                                        containerStyle={{ borderRadius: '0px 0px 10px 10px', border: '1.2px solid #CD171A', background: "#f8f8f8", zIndex: "999" }}
                                        arrowStyle={{ background: "#f8f8f8" }}
                                        isOpen={ActivarPopoverFechas}
                                        position={'bottom'}
                                        disableReposition
                                        onClickOutside={() => setActivarPopoverFechas(false)}
                                        content={() => (
                                            <DateRangePicker
                                                minimumDate={new Date(2019, 0, 1)}
                                                maximumDate={new Date()}
                                                selectedLabel={t('paso1.fechaCompra', 'Fecha de compra o reserva')}
                                                locale={Moment.locale()}
                                                showLegend={true}
                                                firstOfWeek={1}
                                                numberOfCalendars={1}
                                                value={fechaCompra}
                                                onSelect={handleFechaChange}
                                                singleDateRange={true}
                                                selectionType={'single'}
                                            />
                                        )}
                                    >
                                        <input
                                            className="form-control seleccionable w-100"
                                            onClick={() => setActivarPopoverFechas(!ActivarPopoverFechas)}
                                            type="text"
                                            value={fechaCompra ? Moment(fechaCompra).format("YYYY/MM/DD") : ""}
                                            placeholder="AAAA/MM/DD"
                                            readOnly
                                        />
                                    </Popover>
                                </div>
                            </div>
                        </div>

                        {tipoIngreso === 'ticket' && (
                            <div className="row mt-3">
                                <div className="col-12 col-md-6 mb-3">
                                    <h5 className="_c-dark">
                                        <span className="_c-p">*</span> {t('paso1.numeroTicket', 'Número de Ticket')}
                                        {errorTicketUnico && <span className="_c-p animated fadeIn"> - {errorTicketUnico}</span>}
                                    </h5>
                                    <div className="theme-payment-page-form-item form-group">
                                        <input
                                            className="form-control w-100"
                                            type="text"
                                            maxLength={LONGITUD_TICKET}
                                            placeholder={`${PREFIJO_TICKET}...`}
                                            value={numeroTicketUnico}
                                            onChange={(e) => handleTicketUnicoChange(e.target.value)}
                                            onBlur={handleTicketUnicoBlur}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {tipoIngreso === 'localizador' && (
                            <Fragment>
                                <div className="row mt-3">
                                    <div className="col-12 col-md-6 mb-3">
                                        <h5 className="_c-dark">
                                            <span className="_c-p">*</span> {t('paso1.indiqueLocalizador', 'Indique su Booking / Localizador')}
                                            {errorLocalizador && <span className="_c-p animated fadeIn"> - {errorLocalizador}</span>}
                                        </h5>
                                        <div className="theme-payment-page-form-item form-group">
                                            <input
                                                className="form-control w-100"
                                                type="text"
                                                maxLength={LONGITUD_LOCALIZADOR}
                                                placeholder={t('paso1.ejLoc', "Ej: ABCD12")}
                                                value={localizador}
                                                onChange={(e) => handleLocalizadorChange(e.target.value)}
                                                onBlur={handleLocalizadorBlur}
                                                style={{ textTransform: 'uppercase' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-12 mb-3">
                                        <div className="form-group">
                                            <div className="checkbox">
                                                <label style={{ fontSize: '0.9em' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={especificarTicketsLocalizador}
                                                        onChange={handleEspecificarChange}
                                                    />
                                                    <span className="_ml-5">{t('paso1.deseaEspecificar', '¿Desea reembolsar uno o múltiples tickets?')}</span>
                                                </label>
                                            </div>
                                            <small className="d-block _op-07 _mt-0">
                                                {t('paso1.notaEspecificar', 'Si no marca esta opción, se entenderá que el reembolso aplica a todos los tickets asociados al localizador ingresado (si corresponde según las políticas).')}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                {especificarTicketsLocalizador && (
                                    <div className="mt-3">
                                        <h5 className="_c-dark"><span className="_c-p">*</span> {t('paso1.numeroTicket', 'Indique el número de ticket')}
                                            {ticketsDelLocalizador.length === 1 && ticketsDelLocalizador[0].trim() === "" && erroresTicketsLocalizador[0] &&
                                                <span className="_c-p animated fadeIn"> - {erroresTicketsLocalizador[0]}</span>
                                            }
                                        </h5>
                                        {ticketsDelLocalizador.map((ticket, index) => (
                                            <div key={index} className="row align-items-center mb-2">
                                                <div className="col-10 col-md-5">
                                                    <div className="theme-payment-page-form-item form-group">
                                                        <input
                                                            className="form-control w-100"
                                                            type="text"
                                                            maxLength={LONGITUD_TICKET}
                                                            placeholder={`Ticket ${index + 1} (${t('paso1.ejTkt', 'Ej:')} ${PREFIJO_TICKET}...)`}
                                                            value={ticket}
                                                            onChange={(e) => handleTicketLocalizadorChange(index, e.target.value)}
                                                            onBlur={() => handleTicketLocalizadorBlur(index)}
                                                        />
                                                    </div>
                                                    {erroresTicketsLocalizador[index] && ticket.trim() !== "" && <small className="_c-p animated fadeIn d-block">{erroresTicketsLocalizador[index]}</small>}
                                                </div>
                                                <div className="col-2 col-md-1">
                                                    {ticketsDelLocalizador.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-link _c-p p-0"
                                                            onClick={() => removeTicketLocalizadorInput(index)}
                                                            aria-label="Remover ticket"
                                                        >
                                                            <i className="fa fa-minus-circle"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                        <div className="row">
                                            <div className="col-12 col-md-6 mt-3">
                                                <button type="button" className="btn btn-sm theme-btn-secundario" onClick={addTicketLocalizadorInput}>
                                                    <i className="fa fa-plus-circle _mr-5"></i> {t('paso1.añadirTicket', 'Añadir otro ticket')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </Fragment>
                )}
            </div>
        </>
    );
}

export default Paso1;